import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import PhoenixOffcanvas from 'components/base/PhoenixOffcanvas';
import PitchDeckSidebar from 'components/modules/pitchdeck/PitchDeckSidebar';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import React, {
  PropsWithChildren,
  useState,
  useContext,
  useEffect
} from 'react';
import { Col, Row } from 'react-bootstrap';
import ContentToolbar from '../components/modules/pitchdeck/ContentToolbar';
//import { pitchdecks } from 'data/pitchdeck';
import MediaRow from '../components/modules/pitchdeck/MediaRow';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import BulkSelectProvider from 'providers/BulkSelectProvider';
import { media } from 'data/media';
import { Project } from 'data/projects';
import { UserContext } from 'contexts/UserContext';
import projectService from 'services/project';
import NPSpinner from 'components/base/NPSpinner';

interface PitchDeckLayoutProps {
  page: 'media' | 'compose';
}

const PitchDeckLayout = ({
  children,
  page
}: PropsWithChildren<PitchDeckLayoutProps>) => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const { breakpoints } = useBreakpoints();
  const { setContentClass } = useMainLayoutContext();
  const [projectData, setProjectData] = useState<Project | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { projectId } = useParams();
  const navigate = useNavigate();
  const context = useContext(UserContext);

  useEffect(() => {
    if (!context || !context.user) {
      navigate('/pages/authentication/split/sign-in');
    }
  }, []);

  useEffect(() => {
    setIsLoading(true);
    if (projectId) {
      projectService
        .getProjectByID(projectId)
        .then(data => {
          setProjectData(data);
          setIsLoading(false);
        })
        .catch(error => {
          console.error('Error:', error);
          setIsLoading(false);
          if (error.response && error.response.status === 400) {
            navigate('/pages/error/400');
          }
        });
    } else {
      setIsLoading(false);
    }
  }, [projectId, navigate]);

  useEffect(() => {
    setContentClass('pt-0');

    return () => {
      setContentClass('');
    };
  }, []);

  if (isLoading) {
    return <NPSpinner />;
  }
  return (
    <div className="email-container">
      <Row className="gx-lg-4 gx-xl-6 gx-3 py-4 z-index-2 position-sticky bg-soft email-header">
        <Col className="col-auto">
          <Button
            variant="primary"
            className="email-sidebar-width d-none d-lg-block"
            as={Link}
            to="/apps/pitchdeck/save"
            //type="submit"
            endIcon={<FontAwesomeIcon icon={faSave} />}
          >
            Save
          </Button>
          <Button
            variant="phoenix-secondary"
            className="px-3 text-700 d-lg-none"
            onClick={() => setOpenSidebar(true)}
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
        </Col>
        <Col className="col-auto flex-1">
          <h2 className="mb-0">
            <span className="me-3">Project: {projectData?.title}</span>
            <span className="fw-normal text-700">(Edit)</span>
          </h2>
        </Col>
      </Row>
      <Row className="g-lg-4 g-xl-6 mb-8">
        <Col lg="auto">
          <div
            className="email-sidebar email-sidebar-width bg-soft d-none d-lg-block"
            id="pitchdeckSidebarColumn"
          >
            <PitchDeckSidebar />
          </div>

          {breakpoints.down('lg') && (
            <PhoenixOffcanvas
              open={openSidebar}
              fixed
              placement="start"
              className="email-sidebar email-sidebar-width bg-soft"
              backdropClassName="top-0"
              onHide={() => setOpenSidebar(false)}
            >
              <PitchDeckSidebar hideSidebar={() => setOpenSidebar(false)} />
            </PhoenixOffcanvas>
          )}
        </Col>
        {page !== 'media' && (
          <Col xs="3" className="d-none d-lg-block">
            <div className="email-content scrollbar">
              <div className="px-lg-1">
                <BulkSelectProvider data={media}>
                  <ContentToolbar size="sm" />
                  {media.map((mediamodel, index) => (
                    <MediaRow
                      media={mediamodel}
                      index={index}
                      key={mediamodel.mediaId}
                    />
                  ))}
                </BulkSelectProvider>
              </div>
            </div>
          </Col>
        )}
        {children}
      </Row>
    </div>
  );
};

export default PitchDeckLayout;
